import { render, staticRenderFns } from "./ArchiveOrder.vue?vue&type=template&id=66c605e8&scoped=true"
import script from "./ArchiveOrder.vue?vue&type=script&lang=js"
export * from "./ArchiveOrder.vue?vue&type=script&lang=js"
import style0 from "./ArchiveOrder.vue?vue&type=style&index=0&id=66c605e8&prod&lang=css"
import style1 from "./ArchiveOrder.vue?vue&type=style&index=1&id=66c605e8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c605e8",
  null
  
)

export default component.exports